import {
  useIsAdminCenterEnabled,
  useIsQuestionsOnlyMode,
  useIsStorylineAdminEnabled,
} from '@ms/yammer-web-ui-features/dist/featureChecks';
import { useMainFeatureSettings } from '@ms/yammer-web-ui-features/dist/featureSettings';
import { useIsMobileClient, useIsTeamsTab } from 'hooks/selectors';
import { useMemo } from 'react';

type UseAppFeatureSettings = () => ReturnType<typeof useMainFeatureSettings>;
export const useAppFeatureSettings: UseAppFeatureSettings = () => {
  const isAdminCenterEnabled = useIsAdminCenterEnabled();
  const isMobileClient = useIsMobileClient();
  const isTeamsTab = useIsTeamsTab();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isStorylineAdminEnabled = useIsStorylineAdminEnabled();

  const uiFeatureOptions = useMemo<Parameters<typeof useMainFeatureSettings>[0]>(
    () => ({
      overrides: {
        navigation: {
          admin: isAdminCenterEnabled,
          collapsiblePanel: !isQuestionsOnlyMode && !isTeamsTab,
          leftSidebar: !isTeamsTab,
          networks: !isMobileClient,
          settings: !isMobileClient,
          storylinesAdmin: !isQuestionsOnlyMode && !isAdminCenterEnabled && isStorylineAdminEnabled,
        },
        threadPage: {
          groupsExplorerCard: !isQuestionsOnlyMode,
        },
      },
    }),
    [isAdminCenterEnabled, isMobileClient, isQuestionsOnlyMode, isStorylineAdminEnabled, isTeamsTab]
  );

  return useMainFeatureSettings(uiFeatureOptions);
};
